import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import FinancialReportContMain from "presentation/view/container/FinancialReport/FinancialReportContMain";

CommonEntrypoint(<FinancialReportContMain />)